module.exports = __webpack_public_path__ + "assets/images/upgrade-graphic-basic@2x-ff5007779cd4b82c200cc6438153aaf4.jpg";